// site — am. About, Clients, Team and Legal page copy.

export default {
  // About.js
  aboutCommitment: 'የእኛ ባለቤትነት',
  aboutLearnMore: 'ስለእኛ ተጨማሪ ይወቁ',
  aboutWhyChoose: 'ለምን ይሞላሉ',

  // Clients.js
  clientsGroupManufacturers: 'አስተማሪዎች',
  clientsGroupRetailWholesale: 'የችላ እና የጭበራቤ ንግድ',
  clientsCatFoodBeverage: 'የምግብና የመጠጥ ዕቃ የማስኩሰሪያ ድርጅቶች',
  clientsCatGarmentTextile: 'የልብስና የጨርቅ አስተማሪዎች',
  clientsCatShoeLeather: 'የጫማና የቆሎ ምርት አስተማሪዎች',
  clientsCatRetailWholesale: 'የችላ እና የጭበራቤ ንግዶች',
  clientsCatClothingFashion: 'የልብስና የፋሽን ድርጅቶች',
  clientsCatFurnitureAppliance: 'የዕቃና የቤት መሣሪያ ድርጅቶች',
  clientsEthiopia: 'ኢትዮጵያ',

  // Team.js
  teamEmpty: 'እስካሁን የቡድን አባላት የሉም።',

  // Legal.js
  legalTag: 'ሕግ',
  legalNavLabel: 'የፖሊሲ አይነቶች',
  legalTermsTitle: 'የአገልግሎት ድንጋጌዎች',
  legalTermsIntro: 'እነዚህ የአገልግሎት ድንጋጌዎች የAll Things መድረክን አጠቃቀምዎን ይመራሉ። አገልግሎቶቻችን በመድረስ ወይም በመጠቀም በእነዚህ ድንጋጌዎች ተቀርጠዋል።',
  legalTermsS1Heading: '1. መግቢያ',
  legalTermsS1Body: 'ወደ All Things እንኳን በደህና መጡ። እነዚህ የአገልግሎት ድንጋጌዎች የገበያ ማዕከላችን፣ የማርኬቲንግ አገልግሎቶችንና ተዛማኒ ባህሪዎችን ለመጠቀም የሚያስፈልግ ደንቦችንና ስርዓቶችን ያስቀምጡሉ።',
  legalTermsS2Heading: '2. ብቁነት',
  legalTermsS2Body: 'አገልግሎቶቻችን ለመጠቀም ቢያንስ 18 ዓመት የተሞላቸው ሆነና ለሕግ ተቀርጠይ የሚያስችሉ የስምምሮችን የማወጣቸው መሆናችሁ ያስፈልጋለሁ። በምዝገባችሁ የሚሰጡት መረጃ ሁሉ ትክክልና ሙሉ እንደሆነ ያረጋግጣሉ።',
  legalTermsS3Heading: '3. መለያዎች',
  legalTermsS3Body: 'የመለያዎ ምልክት መረጃ በሚስጥር መጠበቅና በመለያዎ ስር የሚከሰቱ ሁሉም እንቅስቃሴ ለእርስዎ ኃላፊነት ይሰጣል። ያልተፈቀደ አጠቃቀም ካለፈከት ወዲያውኑ ያሳወቅን።',
  legalTermsS4Heading: '4. አገልግሎቶችና ክፍያዎች',
  legalTermsS4Body: 'አገልግሎቶቻችን በመድረኩ ላይ እንደተገለጸው ይሰጣሉ። የሚፈጠርበት ክፍያ ከግብይትዎ ወይም ከቦታ ምርጫዎ በፊት በግልጽ ይታያል።',
  legalTermsS5Heading: '5. የተጠቃሚ ሥነም',
  legalTermsS5Body: 'መድረኩን በተገቢው አይጠቀሙም፣ ሕጋዊ ያልሆነ ይዘት አይጫኑም፣ ሌሎችን አይስመስሉም ወይም ሌላ ተጠቃሚዎችን ወይም አገልግሎቶቻችንን ለማዳበር የሚያስችሉ ማንኛውም እንቅስቃሴ አይፈጸሙም በዚህ ተቀርጠዋል።',
  legalTermsS6Heading: '6. የአንጠሳ ባለቤትነት',
  legalTermsS6Body: 'በዚህ መድረክ ላይ ያሉ ሁሉም ይዘቶች፣ ንድፎች፣ ሎጎዎችና ቁሳቄዎች ካልተገለጸ የAll Things ንብረት ናቸው፤ ያለፈቀድ መቅዳት አይቻልም።',
  legalTermsS7Heading: '7. ማጠናቀቅ',
  legalTermsS7Body: 'እነዚህን ድንጋጌዎች የሚጣሉ ወይም ለመድረ኉ ወይም ለሌሎቹ ተጠቃሚዎች ስጋት የሚያስከትሉ መለያዎችን ለማቆም ወይም ለማጠናቀቅ መብትን እናስቀምጠን አለን።',
  legalTermsS8Heading: '8. የኃላፊነት ገደብ',
  legalTermsS8Body: 'በሕግ የሚፈቀድበት ደረጃ ላይ All Things ከመድረኩን ከመጠቀምዎ የሚከሰቱ በድጋሚ፣ በአደጋ ወይም በተደጋጋሚ የሚከሰቱ ጉዳቶች አይሸንፈም።',
  legalTermsS9Heading: '9. ተፈጻሚነት ያለው ሕግ',
  legalTermsS9Body: 'እነዚህ ድንጋጌዎች በየኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ ሕጋት ይመራሉ። አንድም ፍጭት በክሱ ፍርድ ባለቤትነት ብቻ ይሳሳራል።',
  legalPrivacyTitle: 'የግልጽነት ፖሊሲ',
  legalPrivacyIntro: 'የግልጽነትዎ ለእኛ አስፈላጊ ነው። ይህ ፖሊሲ የምንሰበሰበትን መረጃ፣ እንዴት እንጠቀማቸውንና ያላችሁ ያለዎችን ያብራራል።',
  legalPrivacyS1Heading: '1. የምንሰበሰቡት መረጃ',
  legalPrivacyS1Body: 'ስምዎን፣ የኢሜይል አድራሻዎን፣ የስልክ ቁጥርዎንና የክፍያ ዝርዝሮችን የሚሰጡትን መረጃ እንዲሁም በራስ ሁለት የሚሰበሰበው የአጠቃቀም መረጃ እንሰበሰባለን።',
  legalPrivacyS2Heading: '2. የመረጃዎን አጠቃቀም',
  legalPrivacyS2Body: 'የመረጃዎ መረጃ አገልግሎቶቻችን ለመስራትና ለማሻሻል፣ ግብይቶችን ለመከናወን፣ ወርምምዎችን ለመላክ፣ ድጋፍ ለመስጠትና ተሞክሮዎን ለማስተካከል ይጠቀማል።',
  legalPrivacyS3Heading: '3. ኩኪዎች',
  legalPrivacyS3Body: 'መድረካችን የእርስዎን ምርጫዎች ለማስታወስ፣ እንዲሁም ከእርስዎ ጋር እንዴት ይገናኝበትን ለመረጃ መሰብሰብ ኩኪዎችንና ተመሳሳይ ቴክኖሎጂዎችን እንጠቀማለን።',
  legalPrivacyS4Heading: '4. የመረጃ ማጋራት',
  legalPrivacyS4Body: 'የግል መረጃዎን አንጨምራም። የመድረኙን ለመስራት የሚያግዙ የታመን አጋሮችን ወይም በሕግ የሚያስፈልግ በአንዳንድ አጋሮች ብቻ እንጋራለን።',
  legalPrivacyS5Heading: '5. ደህንነት',
  legalPrivacyS5Body: 'መረጃዎ ከያልተፈቀደ መድረስ፣ ከመቀየር ወይም ከማቅረብ ወይም ያለፈቀድ መገንባት ለመጠበቅ የሚገባ የቴክኒክና የመዋቅር አስተዳደር አስፈጽማለን።',
  legalPrivacyS6Heading: '6. መብትዎች',
  legalPrivacyS6Body: 'በማንኛውም ጊዜ የድጋፍ ቡድናችንን በመገናኘት የግል መረጃዎን መድረስ፣ ማስተካከል ወይም መሰረዝ የሚጠይቁ ይችላሉ።',
  legalPrivacyS7Heading: '7. ያግኙን',
  legalPrivacyS7Body: 'ስለዚህ የግልጽነት ፖሊሲ ጥያቄ ካላችሁ allthingsethiopia2026@gmail.com በመላክ ያግኙን።',
  legalBillingTitle: 'የክፍያ ፖሊሲ',
  legalBillingIntro: 'ይህ የክፍያ ፖሊሲ በAll Things መድረክ ላይ ክፍያዎች፣ ክፍያ መጠንና ተመላሽዎች እንዴት እንደሚሠሩ ያብራራል።',
  legalBillingS1Heading: '1. የክፍያ ዘዴዎች',
  legalBillingS1Body: 'በክፍያ ላይ የሚታዩትን የክፍያ ዘዴዎች፣ የባንክ ዝውውርና የሞባይል ክፍያ አማራጮች ጨምሮ ይቀበላለን።',
  legalBillingS2Heading: '2. ዋጋ',
  legalBillingS2Body: 'ግዢዎን ከማረጋገጥዎ በፊት ሁሉም ዋጋዎች በተፈጻሚው ገንዘብ ይታያሉ። ዋጋዎች ያለሳሳድ ማስጠንቀቂያ ሊለወጡ ይችላሉ።',
  legalBillingS3Heading: '3. የክፍያ ዙር',
  legalBillingS3Body: 'ካልተገለጸ ግብይቶች በግዢ ጊዜ ይከናወናሉ። ተደጋጋሚ አገልግሎቶች በእያንዳንዱ የክፍያ ጊዜ መጀመሪያ ይመዳባሉ።',
  legalBillingS4Heading: '4. ያልተሳካቸው ክፍያዎች',
  legalBillingS4Body: 'ክፍያ ካልተሳካ ግብይቱ አይጠናቀቅም ይሳወቅዎታለሁ። እባክዎ የክፍያ ዝርዝሮችዎን ያረጋግጡና እንደገና ይሞክሩ።',
  legalBillingS5Heading: '5. ተመላሽዎች',
  legalBillingS5Body: 'ተመላሽዎች በሻጩ የመመለስ ፖሊሲ መሠረት ይከናወናሉ። በስህተት ክፍያ ተከፍሏል ከምትኩ ያለጎት የድጋፍ ቡድናችንን በ14 ቀናት ውስጥ ያግኙን።',
  legalCookieTitle: 'የኩኪ ፖሊሲ',
  legalCookieIntro: 'ይህ ፖሊሲ ኩኪዎች ምንና በAll Things መድረክ ላይ እንዴት እንጠቀማቸውን ያብራራል።',
  legalCookieS1Heading: '1. ኩኪዎች ምንና ናቸው',
  legalCookieS1Body: 'ኩኪዎች ሲጎቡ አንድ ድህረ ገጽ ሲጎቡ በመሣሪያዎ ላይ የሚቀመጡ ትንችሽን የመልዕክት ፋይሎች ናቸው። ድህረ ገጹ በትክክል እንዲሠራ እና የእርስዎን ምርጫዎች እንዲያስታወስ ይረዳሉ።',
  legalCookieS2Heading: '2. ኩኪዎችን እንዴት እንጠቀማለን',
  legalCookieS2Body: 'እርስዎን በግባ ለመድረግ፣ የቋንቋና የገጽታ ምርጫዎችዎን ለማስታወስ፣ የአጠቃቀም ንድፍ ለመረጃ፣ መድረኩንም ለማሻሻል ኩኪዎችን እንጠቀማለን።',
  legalCookieS3Heading: '3. ኩኪዎችን መቆጠብ',
  legalCookieS3Body: 'ኩኪዎችን በአሳሾዎ ቅንብር ማዋቀር ወይም ማጥፋት ይችላሉ። ኩኪዎችን ማሰራተን የመድረኩን አንዳንድ ባህሪዎች ሊጎደሉ ይችላሉ።',
  legalCopyrightTitle: 'የካፒታ ጥገኝ አያያዝ ፖሊሲ',
  legalCopyrightIntro: 'የሌሎች የአንጠሳ ባለቤትነት መብትን እናበረከን እንጠበቃለን፣ ተጠቃሚዎችም የተመሳሳይ እንደሆነ እንጠብቃለን።',
  legalCopyrightS1Heading: '1. ማስጠንቀቂያ ማቅረብ',
  legalCopyrightS1Body: 'በመድረካችን ላይ ያለ ይዘት ካፒቲዎን እየጣሰ ከሆነ የጉዳቱን የአካባቢ መረጃና የቤተሰብ ማረጋገጫ የሚያካት ማስጠንቀቂያ እባክዎ ያስገቡ።',
  legalCopyrightS2Heading: '2. የተቃራጒ ማስጠንቀቂያ',
  legalCopyrightS2Body: 'ይዘትዎ በስህተት ከተወገደ ከሆነ በምክንያቱም ይዘቱ መመለስ የሚገበረውን ለማብራራት የተቃራጒ ማስጠንቀቂያ ማቅረብ ይችላሉ።',
  legalCopyrightS3Heading: '3. ተደጋጋሚ ጥገኝ ያላለፈበት',
  legalCopyrightS3Body: 'ጥገኝ ይዘት በደጋጋሚ የሚለጡ መለያዎች በፈቃናችን ሊቆሙ ወይም ሊጠፋሉ ይችላሉ።',
};